import Vue from "vue";
import Router from "vue-router";

import { auth, userRedirect } from "@/common/middleware";
import Login from "../pages/auth/login";

import MerchantList from "../pages/marshals/index";
import Feedback from "../pages/marshals/feedback";
import Report from "../pages/marshals/report"

import CCMerchantList from "../pages/cc/index";
import CCUpdateMerchant from "../pages/cc/merchantUpdate";
import CCUpdateLocation from "../pages/cc/locationUpdate";
import CCAllMerchants from "../pages/cc/merchantList";

import Admin from "../pages/admin/index.vue";

import AllMerchants from "../pages/admin/merchants.vue";
import AdminMerchant from "../pages/admin/merchant/index.vue";

import Schedule from "../pages/admin/schedule/index.vue";
import AdminMarshal from "../pages/admin/marshals.vue";

import BankReport from "../pages/admin/report/index";

// import Analytics from "../pages/admin/analytics/index.vue";
import Analytics from "../pages/admin/analytics/index";

import CreateMarshal from "../pages/admin/create/marshal";
import CreateMerchant from "../pages/admin/create/merchant";
import CreateMerchantLocation from "../pages/admin/create/merchantLocation";

import store from "@/store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/marshal");
};

const router = new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/",
      name: "LoginPage",
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/marshal",
      name: "MerchantListPage",
      component: MerchantList,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/marshal/feedback/:location_id",
      name: "FeedbackPage",
      component: Feedback,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/marshal/reports",
      name: "MarshalReport",
      component: Report,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/cc",
      name: "CCMerchantList",
      component: CCMerchantList,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/cc/location-update/:location_id",
      name: "CCUpdateLocation",
      component: CCUpdateLocation,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/cc/merchant-update/:merchant_id",
      name: "CCUpdateMerchant",
      component: CCUpdateMerchant,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/cc/merchants/:merchant_id",
      name: "CCAllMerchants",
      component: CCAllMerchants,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/cc/merchants/:merchant_id/locations/:location_id",
      name: "CCAllMerchants",
      component: CCAllMerchants,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/tracker",
      name: "Tracker",
      component: Admin,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    // {
    //   path: "/tracker/marshal",
    //   name: "AdminMarshal",
    //   component: AdminMarshal,
    //   meta: {
    //     // middleware: [auth, userRedirect]
    //   }
    // },
    {
      path: "/admin/route-marshals",
      name: "Schedule",
      component: Admin,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/route-marshals/:id",
      name: "AdminMarshal",
      component: AdminMarshal,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/merchants",
      name: "AdminMerchants",
      component: AllMerchants,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/merchants/:id",
      name: "AdminMerchant",
      component: AdminMerchant,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/merchants/:id/locations/:location_id",
      name: "AdminMerchant",
      component: AdminMerchant,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/reports",
      name: "BankReport",
      component: BankReport,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/analytics",
      name: "Analytics",
      component: Analytics,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/create/marshal",
      name: "CreateMarshal",
      component: CreateMarshal,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/create/merchant",
      name: "CreateMerchant",
      component: CreateMerchant,
      meta: {
        middleware: [auth, userRedirect]
      }
    },
    {
      path: "/admin/create/merchantLocation",
      name: "CreateMerchantLocation",
      component: CreateMerchantLocation,
      meta: {
        middleware: [auth, userRedirect]
      }
    }
  ]
});

export default router;

// https://markus.oberlehner.net/blog/implementing-a-simple-middleware-with-vue-router/
// i catch una
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});
